<template>
    <div class="author-noms">
      <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
      <transition name="fade">
        <div v-if="contentReady && contentLoadError === ''">
          <ContentHeader :name="$route.name"></ContentHeader>
           <div class="row">
            <div class="col-sm-12">
              <h3>{{ headerLabel }}</h3>
              <table class="table table-hover" v-if="authorNominations.length">
                <thead>
                  <tr>
                    <th>{{ firstTH }}</th>
                    <th>ID</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, index) in authorNominations">
                    <td>{{ getWorkflowTeam(data.nominationteam[0], data.nominee_name[0], data, firstTH) }}</td>
                    <td><router-link :to="{path: '/my-profile/review-nomination/' + data.id }">{{ data.id }}</router-link></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </transition>
    </div>
</template>

<script>
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import WordpressRestURI from '@/helpers/WordpressRestURI.js'
import ContentHeader from '@/components/ContentHeader'
import PreContentHeader from '@/components/PreContentHeader'

export default {
  components: {
    PreContentHeader,
    ContentHeader
  },
  data () {
    return {
      contentReady: false,
      contentLoadError: '',
      authorId: '',
      authorName: '',
      afterDate: '',
      catName: '',
      catCount: '',
      authorNominations: '',
      headerLabel: '',
      firstTH: ''
    }
  },
  created () {
    this.authorId = localStorage.getItem('paramAuthor')
    this.authorName = localStorage.getItem('paramAuthorName')
    this.afterDate = localStorage.getItem('paramDate')
    this.catName = localStorage.getItem('paramName')
    this.catCount = localStorage.getItem('paramCount')
    localStorage.removeItem('paramAuthor')
    localStorage.removeItem('paramAuthorName')
    localStorage.removeItem('paramDate')
    localStorage.removeItem('paramName')
    localStorage.removeItem('paramCount')
    console.log(this.authorId, this.afterDate)
    console.log(this.catName, this.catCount)
    if (this.afterDate === 'All') {
      this.afterDate = ''
    }
    else {
      this.afterDate = '&after=' + this.afterDate
    }
    let catID = ''
    if (this.catName === "High5")
      catID = '102'
    else if (this.catName === "On the Spot")
      catID = '103'
    else if (this.catName === "Teams")
      catID = '104'

    if (this.authorId.includes('-co')) {
      this.headerLabel = this.$route.params.cat + ' for ' + this.authorName
      this.firstTH = 'Nominator'
      WordpressRestAPI.getCustomViewContent('getNomination/v1/getpostbyslug?nomineeSlug=' + this.authorId + this.afterDate + '&tid=' + catID)
      .then(response => {
        console.log('data includes', response.data)
        WordpressRestAPI.getViewContent('nomination?_embed&' + response.data)
        .then(response => {
          console.log('data', response.data)
          this.authorNominations = response.data
          this.contentReady = true
        })
        .catch(e => {
          this.contentLoadError = 'Oops! We had a problem with loading Nomination. Please try again later.'
          console.error(e)
          this.contentReady = true
        })
      })
      .catch(e => {
        this.contentLoadError = 'Oops! We had a problem with loading Nomination. Please try again later.'
        console.error(e)
        this.contentReady = true
      })
    }
    else {
      this.headerLabel = this.$route.params.cat + ' by ' + this.authorName
      this.firstTH = 'Nominee'
      WordpressRestAPI.getViewContent('nomination?author=' + this.authorId + this.afterDate + '&nomination_event_category=' + catID)
      .then(response => {
        console.log('data', response.data)
        this.authorNominations = response.data
        this.contentReady = true
      })
      .catch(e => {
        this.contentLoadError = 'Oops! We had a problem with loading Nomination. Please try again later.'
        console.error(e)
        this.contentReady = true
      })
    }
  },
  mounted () {
  },
  methods: {
    getWorkflowTeam: function (nominationteam, nominee_name, nomination, firstTH) {
      if (firstTH === 'Nominee') {
        if (nominationteam) {
          let names = []
          nominationteam.map(function(n) {
            names.push(n.member_name)
          })
          return names.join(', ')
        } else {
          return nominee_name
        }
      } else if (firstTH === 'Nominator') {
        return nomination._embedded['author'][0].name
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/routes/AuthorNomsList.vue